/**
 * Rinkiniu blokas prekes puslapyje.
 *
 * Krauna is layout/theme.liquid, o ne inline is bloko, nes Horizon perpiesia
 * sekcijas ir inline <script> tada nebeivykdomas.
 */
(function () {
  var root;
  var picker;
  var tiles;
  var activeSlot = null;
  var chosen = [];
  var cache = {};
  var T = {};

  function currentTile() {
    return root.querySelector('.psc-bundle.is-selected');
  }

  function tierQty(tile) {
    return parseInt(tile.getAttribute('data-qty'), 10) || 1;
  }

  function showError(msg) {
    var el = document.getElementById('psc-bundles-error');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        cache[handle] = data;
        return data;
      });
  }

  /** Pirma reiksme, kuri turi sandelyje bent viena varianta. */
  function firstAvailable(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function matchVariant(product, values) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (v.options[j] !== values[j]) ok = false;
      }
      if (ok) return v;
    }
    return null;
  }

  function renderSlots() {
    var tile = currentTile();
    if (!tile) return;
    var qty = tierQty(tile);

    while (chosen.length < qty) chosen.push(null);
    chosen.length = qty;

    var slots = tile.querySelectorAll('.psc-slot');
    Array.prototype.forEach.call(slots, function (slot, index) {
      var pick = chosen[index];
      var thumb = slot.querySelector('.psc-slot__thumb');
      var name = slot.querySelector('.psc-slot__name');
      var opts = slot.querySelector('.psc-slot__options');
      var btn = slot.querySelector('.psc-slot__btn');
      if (btn) btn.textContent = pick ? T.change || 'Keisti' : T.pick || 'Pasirinkti';

      if (!pick) {
        slot.classList.add('is-empty');
        thumb.innerHTML = '<span class="psc-slot__plus" aria-hidden="true">+</span>';
        name.textContent = T.choose || 'Pasirink dizainą';
        opts.innerHTML = '';
        return;
      }

      slot.classList.remove('is-empty');
      thumb.innerHTML = '<img src="' + pick.image + '" alt="" width="32" height="32">';
      name.textContent = pick.title;

      opts.innerHTML = '';
      pick.product.options.forEach(function (option, optionIndex) {
        var select = document.createElement('select');
        select.setAttribute('aria-label', (T.options && T.options[option.name]) || option.name);
        option.values.forEach(function (value) {
          var opt = document.createElement('option');
          opt.value = value;
          opt.textContent = (T.colours && T.colours[value]) || value;
          if (pick.values[optionIndex] === value) opt.selected = true;
          select.appendChild(opt);
        });
        select.addEventListener('change', function () {
          var values = [].map.call(opts.querySelectorAll('select'), function (s) {
            return s.value;
          });
          var variant = matchVariant(pick.product, values);
          if (!variant) {
            showError(T.err_combo || 'Tokio derinio nėra. Pasirink kitą dydį ar spalvą.');
            return;
          }
          pick.values = values;
          pick.variantId = variant.id;
          pick.touched = true;
          pick.image = variantImage(variant, pick.fallbackImage);
          var img = slot.querySelector('.psc-slot__thumb img');
          if (img) img.src = pick.image;
          showError(variant.available ? '' : T.err_sold || 'Šis derinys išparduotas.');
        });
        opts.appendChild(select);
      });
    });
  }

  /** Photo of the variant, so the slot thumbnail matches the chosen colour. */
  function variantImage(variant, fallback) {
    var img = variant && variant.featured_image && variant.featured_image.src;
    return img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=120' : fallback;
  }

  /** Variant currently selected in the page's own size and colour picker. */
  function pageVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function setSlot(index, product, title, image, preferId) {
    var variant = firstAvailable(product);
    if (preferId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === preferId && product.variants[i].available) variant = product.variants[i];
      }
    }
    chosen[index] = {
      handle: product.handle,
      product: product,
      title: title || product.title,
      fallbackImage: image || product.featured_image || '',
      image: variantImage(variant, image || product.featured_image || ''),
      values: variant.options.slice(),
      variantId: variant.id,
    };
    renderSlots();
  }

  function syncFirstSlot() {
    var first = chosen[0];
    var id = pageVariantId();
    if (!first || first.touched || !id || first.variantId === id) return;
    if (first.handle !== root.getAttribute('data-product')) return;
    setSlot(0, first.product, first.title, first.fallbackImage, id);
  }

  function select(tile) {
    syncFirstSlot();
    Array.prototype.forEach.call(tiles, function (t) {
      var on = t === tile;
      t.classList.toggle('is-selected', on);
      var btn = t.querySelector('.psc-bundle__pick');
      if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    showError('');
    renderSlots();
  }

  function openPicker(index) {
    activeSlot = index;
    picker.hidden = false;
    document.body.style.overflow = 'hidden';
    var search = document.getElementById('psc-picker-search');
    if (search) {
      search.value = '';
      filterPicker('');
    }
  }

  function closePicker() {
    picker.hidden = true;
    activeSlot = null;
    document.body.style.overflow = '';
  }

  function filterPicker(term) {
    var needle = (term || '').trim().toLowerCase();
    Array.prototype.forEach.call(picker.querySelectorAll('.psc-picker__item'), function (item) {
      var hay = item.getAttribute('data-search') || '';
      item.style.display = !needle || hay.indexOf(needle) !== -1 ? '' : 'none';
    });
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.slice(0, 4);
  }

  function addBundle() {
    var tile = currentTile();
    var qty = tierQty(tile);
    var picks = chosen.slice(0, qty);

    if (
      picks.some(function (p) {
        return !p;
      })
    ) {
      showError(T.err_all || 'Pasirink visus marškinėlius.');
      return;
    }

    var sections = cartSectionIds();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: picks.map(function (p) {
          return { id: p.variantId, quantity: 1 };
        }),
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (state) {
        if (state.status) {
          showError(state.description || state.message || T.err_add);
          return;
        }
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var event = new Event('cart:update', { bubbles: true });
            event.detail = {
              resource: cart,
              sourceId: 'psc-bundles',
              data: {
                source: 'product-form-component',
                itemCount: cart.item_count,
                sections: state.sections,
              },
            };
            document.dispatchEvent(event);
          });
      })
      .catch(function () {
        showError(T.err_add || 'Nepavyko įdėti į krepšelį. Bandyk dar kartą.');
      });
  }

  function isMultiTier() {
    var tile = currentTile();
    return !!tile && tierQty(tile) > 1;
  }

  function startClock() {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }
    function tick() {
      var el = document.getElementById('psc-bundle-clock');
      if (!el) return;
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var s = Math.floor((end - now) / 1000);
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    root = document.getElementById('psc-bundles');
    picker = document.getElementById('psc-picker');
    if (!root || !picker || root.dataset.pscReady) return;
    root.dataset.pscReady = '1';

    try {
      T = JSON.parse((document.getElementById('psc-bundles-i18n') || {}).textContent || '{}');
    } catch (e) {
      T = {};
    }

    tiles = root.querySelectorAll('.psc-bundle');

    Array.prototype.forEach.call(tiles, function (tile) {
      var pick = tile.querySelector('.psc-bundle__pick');
      if (pick) {
        pick.addEventListener('click', function () {
          select(tile);
        });
      }
      Array.prototype.forEach.call(tile.querySelectorAll('.psc-slot__btn'), function (btn) {
        btn.addEventListener('click', function () {
          openPicker(parseInt(btn.closest('.psc-slot').getAttribute('data-slot'), 10));
        });
      });
    });

    picker.addEventListener('click', function (event) {
      if (event.target.hasAttribute('data-close')) {
        closePicker();
        return;
      }
      var btn = event.target.closest('.psc-picker__btn');
      if (btn && activeSlot !== null) {
        var index = activeSlot;
        fetchProduct(btn.getAttribute('data-handle')).then(function (product) {
          setSlot(index, product, btn.getAttribute('data-title'), btn.getAttribute('data-image'));
          showError('');
        });
        closePicker();
      }
    });

    document.addEventListener('keyup', function (event) {
      if ((event.key === 'Escape' || event.code === 'Escape') && !picker.hidden) closePicker();
    });

    var search = document.getElementById('psc-picker-search');
    if (search) {
      search.addEventListener('input', function () {
        filterPicker(search.value);
      });
    }

    // Kelių prekių pakopos negali eiti per vienos prekės formą.
    document.addEventListener(
      'click',
      function (event) {
        if (!isMultiTier()) return;
        var addBtn = event.target.closest('button[name="add"], .add-to-cart-button');
        if (!addBtn) return;
        event.preventDefault();
        event.stopPropagation();
        addBundle();
      },
      true
    );

    // Pirmas lizdas uzpildomas ta preke, kuria pirkejas ziuri.
    fetchProduct(root.getAttribute('data-product')).then(function (product) {
      if (!chosen[0]) setSlot(0, product, null, null, pageVariantId());
      select(root.querySelector('.psc-bundle.is-selected') || tiles[0]);
    });

    /* PSC redesign: fake daily countdown removed (see blocks/psc-bundles.liquid) */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
